export class AiStructuredDataHelper {
  static apiBaseUrl = "https://buster.cheapcharts.de/v1/gptapi/";

  static buildDealsPageSchema(name: string, url: string, country: string, store: string, itemType: string, quality?: string): any {
    const params = [
      { key: "action", value: "getDeals" },
      { key: "store", value: AiStructuredDataHelper.getValueOrDefault(store, "itunes") },
      { key: "country", value: AiStructuredDataHelper.getValueOrDefault(country, "us") },
      { key: "itemType", value: AiStructuredDataHelper.getValueOrDefault(itemType, "buymovies") },
      { key: "sort", value: "greatestSavings" },
      { key: "limit", value: "20" }
    ];

    if (quality) {
      params.splice(4, 0, { key: "quality", value: quality });
    }

    return {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": name,
      "url": url,
      "potentialAction": {
        "@type": "SearchAction",
        "name": "Find CheapCharts deals via GPT API",
        "target": AiStructuredDataHelper.apiBaseUrl + "Deals.php?" + AiStructuredDataHelper.toQueryString(params),
        "query-input": [
          "optional name=genre",
          "optional name=maxPrice",
          "optional name=quality"
        ]
      }
    };
  }

  static buildSearchPageSchema(country: string, store: string): any {
    const countryValue = AiStructuredDataHelper.getValueOrDefault(country, "us");
    const storeValue = AiStructuredDataHelper.getValueOrDefault(store, "itunes");

    return {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "CheapCharts Search",
      "url": "https://www.cheapcharts.com/" + countryValue + "/search",
      "potentialAction": {
        "@type": "SearchAction",
        "name": "Search CheapCharts via GPT API",
        "target": AiStructuredDataHelper.apiBaseUrl + "Search.php?action=search&store=" + encodeURIComponent(storeValue) + "&country=" + encodeURIComponent(countryValue) + "&itemType=all&query={search_term_string}&limit=10",
        "query-input": "required name=search_term_string"
      }
    };
  }

  static buildDetailPotentialAction(country: string, store: string, item: any): any {
    const countryValue = AiStructuredDataHelper.getValueOrDefault(country, "us");
    const storeValue = AiStructuredDataHelper.getValueOrDefault(store, "itunes");
    const imdbId = item ? (item.imdbId || item.imdbID) : "";
    const title = item && item.title ? item.title : "";

    if (item && item.itemType == "movie" && imdbId) {
      return {
        "@type": "Action",
        "name": "Get CheapCharts GPT API price data",
        "target": AiStructuredDataHelper.apiBaseUrl + "Prices.php?action=getPrices&store=" + encodeURIComponent(storeValue) + "&country=" + encodeURIComponent(countryValue) + "&itemType=buymovies&imdbIDs=" + encodeURIComponent(imdbId)
      };
    }

    return {
      "@type": "SearchAction",
      "name": "Search CheapCharts via GPT API",
      "target": AiStructuredDataHelper.apiBaseUrl + "Search.php?action=search&store=" + encodeURIComponent(storeValue) + "&country=" + encodeURIComponent(countryValue) + "&itemType=all&query=" + encodeURIComponent(title) + "&limit=5"
    };
  }

  private static getValueOrDefault(value: string, defaultValue: string): string {
    return value ? value : defaultValue;
  }

  private static toQueryString(params: Array<{ key: string, value: string }>): string {
    return params.map(param => {
      return encodeURIComponent(param.key) + "=" + encodeURIComponent(param.value);
    }).join("&");
  }
}
